import { FormikProps } from 'formik';
import { OptionCard } from './OptionCard';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';

interface QuestionOptionsSectionProps {
  formik: FormikProps<QuestionFormValues>;
  selectedTeams?: string[];
  translateField: (
    sourceKey: string,
    sourceValue: string,
    targetKey: string,
    setFieldValue: any
  ) => void;
  isFieldTranslating: (key: string) => boolean;
  isEditable: boolean;
}

export function QuestionOptionsSection({
  formik,
  selectedTeams = [],
  translateField,
  isFieldTranslating,
  isEditable,
}: QuestionOptionsSectionProps) {
  const { errors, touched, values } = formik;

  if (values.question_type === 'tiebreaker') {
    return null;
  }

  return (
    <div className="border-t pt-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold">Answer Options</h3>
        {typeof errors.options === 'string' && touched.options && (
          <span className="text-sm text-red-500">{errors.options}</span>
        )}
      </div>

      <div className="space-y-4">
        {values.options.map((_, index) => (
          <OptionCard
            key={index}
            index={index}
            formik={formik}
            selectedTeams={selectedTeams}
            translateField={translateField}
            isFieldTranslating={isFieldTranslating}
            isEditable={isEditable}
          />
        ))}

        {values.options.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">No options available.</div>
        )}
      </div>
    </div>
  );
}
